export class ForkInspectionTemplateError extends Error {
  constructor(message: string = 'Failed to fork inspection template') {
    super(message);
    this.name = 'ForkInspectionTemplateError';
  }
}
